import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { CompanyOwnershipService } from '@app/shared/services/company-ownership.service';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { AffiliateTypeModal } from '../../modals/affiliate-type-modal/affiliate-type-modal.component';
import { AssignDocumentTypeModal } from '../../modals';

@Component({
  selector: 'app-company-affiliate-types',
  templateUrl: './company-data-management.component.html',
  styleUrls: ['./company-data-management.component.scss'],
})
export class CompanyDataManagementComponent implements OnInit {
  success: any = false;
  error = false;
  pending = false;
  FAQs = [];
  companyRecords = [];
  recordsToDisplay;
  totalItems = 0;
  rows = 10;
  maxSize = 3;
  currentPage = 1;
  filter = {};
  constructor(
    private location: Location,
    private companyOwnershipService: CompanyOwnershipService,
    private modalService: SuiModalService
  ) {
    this.getTypes();
  }

  ngOnInit(): void {}

  goBack() {
    this.location.back();
  }
  getObjectKeys(data) {
    if (data) {
      return Object.keys(data);
    }
  }
  getTypes() {
    this.pending = true;
    this.companyOwnershipService.getGroupedObject().subscribe(
      (res: any) => {
        console.log(res);
        this.pending = false;
        this.companyRecords = res;
        this.recordsToDisplay = this.companyRecords;
        this.appendCollapseState(this.recordsToDisplay);
        this.totalItems = this.companyRecords.length;
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage ? error.error.errorMessage
                                              : error.error ? error.error
                                              : error;
      }
    );
  }

  searchRecords(event) {
    this.recordsToDisplay = [];
    this.companyRecords.forEach((record) => {
      if (record.companyTypeName.toLowerCase().includes(event)) {
        this.recordsToDisplay.push(record);
      }
    });
    this.totalItems = this.recordsToDisplay.length;
  }

  displayRecords(event) {}

  sortRecords(event) {
    this.recordsToDisplay.reverse();
  }

  nextPage(event) {}

  toggleAffiliateTypesVisibility(index: number) {
    this.documentTypes[index]['isCollapsed'] =
      !this.documentTypes[index]['isCollapsed'];
  }

  addAffiliateType(companyTypeId = '') {
    this.modalService
      .open(new AffiliateTypeModal(companyTypeId, this.companyRecords))
      .onApprove(() => {});
  }
  documentTypes;
  appendCollapseState(data) {
    // console.log(data, 'data');
    this.documentTypes = data;
    this.documentTypes.forEach((companyRecord) => {
      companyRecord['isCollapsed'] = true;
    });
    console.log(this.documentTypes, 'arrayOfObjects');
  }
  assignDocuments(group) {
    let users = [];
    // group.users.forEach((user) => {
    //   users.push(JSON.parse(user)['app_user_id']);
    // });
    console.log(group.optionId, 'group.optionId');
    this.modalService
      .open(
        new AssignDocumentTypeModal(
          `Assign Document Type`,
          group.optionId,
          group.groupedDocumentType,
          ModalSize.Small
        )
      )
      .onApprove((value) => {
        this.success = value;
        this.getTypes();
      })
      .onDeny(() => {
        this.getTypes();
      });
  }
}
